import { useRef } from "react";
import { useDispatch } from "react-redux";
import { setMetaExtendedBulk, setMetaFoldedBulk } from "../../../abstract/redux/slice/metaSlice";
import IconArrowClockwise from "../../../themes/icons/IconArrowClockwise";
import { IconWindowMaximize3 } from "../../../themes/icons/IconWindowMaximize3";
import { IconWindowMinimize3 } from "../../../themes/icons/IconWindowMinimize3";
import { Canvas } from "../canvas/Canvas";
import styles from "./BodyViewGlobalParameters.module.scss";

function BodyViewGlobalParameters({ nodeRoot, showGlobals, setShowGlobals, setShowFunction }) {
  const _dispatch = useDispatch();

  const _isFolded = useRef(false);

  const handleButtonFold = (e) => {
    e.stopPropagation();

    _isFolded.current = !_isFolded.current;

    _dispatch(setMetaExtendedBulk(nodeRoot, false));
    _dispatch(setMetaFoldedBulk(nodeRoot, _isFolded.current));
  };

  const handleViewShow = () => {
    const _value = Boolean(showGlobals);

    setShowGlobals(!_value);
    setShowFunction(true);
  };

  return (
    <div className={styles["global"]}>
      <div className={styles["header"]} role="button" onClick={handleViewShow}>
        {showGlobals && (
          <div
            className={`${styles["icon"]} ${styles["icon--fold"]}`}
            role="button"
            onClick={handleButtonFold}>
            <IconArrowClockwise />
          </div>
        )}
        <div id="header_globals">global parameters</div>
        <div className={`${styles["icon"]} ${styles["icon--show"]}`}>
          {showGlobals ? <IconWindowMinimize3 /> : <IconWindowMaximize3 />}
        </div>
      </div>
      <div className={`${styles["container"]}`}>
        {showGlobals && <Canvas node={nodeRoot} isGlobal={true} />}
      </div>
    </div>
  );
}

export default BodyViewGlobalParameters;
